"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
interface AnalyticsProps {
  profile: any;
}
const DEFAULT_ANALYTICS_CONSENT_CATEGORY = "C0002";

// Hotfix: consent-gating (useResolvedAlgoliaConsent) removed — it was
// dropping GTM/Aptrinsic for a large share of visitors due to a
// consent-detection race. GTM/Aptrinsic load unconditionally again
// whenever a gtmId is configured, matching pre-9/17 behavior.
const Analytics = t0 => {
  const $ = _c(6);
  const {
    profile
  } = t0;
  const gtmId = profile?.NEXT_PUBLIC_GTM_ID;
  if (!gtmId) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Script id="_next-gtm-init" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: "\n            window.dataLayer = window.dataLayer || [];\n            window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});\n          "
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <Script id="_next-gtm" strategy="lazyOnload" src={t2} />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Script id="gainsight-script" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: `
            const appMode = "${process.env.NEXT_PUBLIC_ECOM_ENV}";
            const aptrinsicConfig = {};
            let aptrinsicId;
            switch (appMode) {
                case 'prod':
                    aptrinsicId = 'AP-UNM677VB2XAD-2';
                    break;
                case 'dev':
                case 'local':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
                    break;
                case 'qa':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-3';
                    break;
                case 'sit':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-4';
                    break;
                default:
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
            }
            (function (n, t, a, e, co) {
                var i = 'aptrinsic';
                (n[i] =
                    n[i] ||
                    function () {
                        (n[i].q = n[i].q || []).push(arguments);
                    }),
                    (n[i].p = e);
                n[i].c = co;
                var r = t.createElement('script');
                (r.async = !0), (r.src = a + '?a=' + e);
                var c = t.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(r, c);
            })(
                window,
                document,
                'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
                aptrinsicId,
                aptrinsicConfig
            );
            `
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <>{t1}{t3}{t4}</>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default Analytics;